import { BaseComponent } from '../../base-component';
import { ARTICLE_OPTIONS_CHANGED_EVENT } from '../../article-options/client/events';

export class DeliveryComponent extends BaseComponent {
    public rootSelector = '.js_pdp_delivery';
    public static AVAILABILITY_MESSAGE_SELECTOR = '.js_availabilityMessage_Feature';
    public static AVAILABILITY_MESSAGE_SLOW_SELECTOR = '.js_availabilityMessageSlow_Feature';

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent() || !document.querySelector('.js_pdp_delivery__note')) {
            return;
        }
        this.performViewTracking();
        this.processDeliverySlowFeature();
    }

    private performViewTracking(): void {
        const trackingKeys = this.getLinkElements().map(e => e.dataset.trackingKey);

        if (!trackingKeys.length) {
            return;
        }

        this.trackView({
            product_DeliveryServiceActivity: 'view',
            product_DeliveryServiceType: trackingKeys.join('|'),
        });
    }

    private getLinkElements(): HTMLElement[] {
        return this.getChildElements('*[data-tracking-key]');
    }

    private processDeliverySlowFeature() {
        if (this.getRootElement().dataset.deliveryOnDemand === 'true') {
            o_global.eventQBus.on(ARTICLE_OPTIONS_CHANGED_EVENT, () => {
                const selectedServicesChangeDeliveryMessageToSlow = Array.from(
                    document.querySelectorAll<HTMLInputElement>('[data-delivery-within48h="false"]')
                ).filter(service => service.checked).length;

                this.switchShownDeliveryMessage(selectedServicesChangeDeliveryMessageToSlow > 0);
            });
        } else if (this.getRootElement().dataset.deliveryOnDemand === 'false') {
            this.switchShownDeliveryMessage(true);
        } else {
            o_global.eventQBus.off(ARTICLE_OPTIONS_CHANGED_EVENT, () => {});
        }
    }

    private switchShownDeliveryMessage(showSlowMessage: boolean) {
        const hiddenCssClass = 'pl_hidden';
        const availabilityMessageElement = this.getChildElement(DeliveryComponent.AVAILABILITY_MESSAGE_SELECTOR);
        const availabilityMessageSlowElement = this.getChildElement(DeliveryComponent.AVAILABILITY_MESSAGE_SLOW_SELECTOR);

        if (showSlowMessage && availabilityMessageSlowElement.classList.contains(hiddenCssClass)) {
            availabilityMessageElement.classList.add(hiddenCssClass);
            availabilityMessageSlowElement.classList.remove(hiddenCssClass);
        } else if (!showSlowMessage && availabilityMessageElement.classList.contains(hiddenCssClass)) {
            availabilityMessageElement.classList.remove(hiddenCssClass);
            availabilityMessageSlowElement.classList.add(hiddenCssClass);
        }
    }
}
